import { Outlet, useParams } from "react-router-dom";
import { TournamentProvider } from "@/hooks/useTournament";

/**
 * Layout wrapper that provides TournamentContext to all child routes.
 * Used at /tournaments/:slug/* to inject tournament config & data.
 */
export function TournamentLayout() {
  const { slug } = useParams<{ slug: string }>();

  return (
    <TournamentProvider tournamentSlug={slug}>
      <Outlet />
    </TournamentProvider>
  );
}
